import React from 'react';
import { HomeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-surface-line bg-white" data-id="element-66" data-mp="3gf96f0gd6eb2">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-5 py-8 sm:px-6 md:flex-row md:items-center md:justify-between" data-id="element-67" data-mp="3ghc3g4fxp7pa">
        <div className="flex items-start gap-2.5" data-id="element-68" data-mp="36p6df098t0cq">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-soft text-brand" data-id="element-69" data-mp="36pzaf9iegbho">
            <HomeIcon className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="3ucxoy1myl9cy" />
          </span>
          <div data-id="element-71" data-mp="387czflhuzc3">
            <p className="text-sm font-extrabold tracking-tight text-ink-strong" data-id="element-72" data-mp="37xuse6oxwgy">
              ANFITRIÓN PRO 365™
            </p>
            <p className="mt-0.5 max-w-lg text-xs leading-relaxed text-ink-muted" data-id="element-73" data-mp="3qd6qrcv3rqye">
              El sistema operativo para anfitriones de Airbnb y alquileres
              temporarios en Latinoamérica y España.
            </p>
          </div>
        </div>
        <p className="text-[11px] leading-relaxed text-ink-muted md:text-right" data-id="element-74" data-mp="2ezuubn1oaam9">
          © {new Date().getFullYear()} Anfitrión Pro 365. Producto digital
          independiente,
          <br className="hidden md:block" data-id="element-75" data-mp="3gbikcl8ypbyn" /> no afiliado a Airbnb, Inc.
        </p>
      </div>
    </footer>;
}